import { ConsumablesProductDetailsContainerComponent } from "@/components/ConsumablesProductDetailsContainer/ConsumablesProductDetailsContainer.builder";
import { ProductSpecificationComponent } from "@/components/ProductSpecification/ProductSpecification.builder";
import { ProductTeaserCarouselComponent } from "@/components/ProductTeaserCarousel/ProductTeaserCarousel.builder";
import { StandardProductDetailsContainerComponent } from "@/components/StandardProductDetailsContainer/StandardProductDetailsContainer.builder";

export const productCustomComponents: RegisteredComponent[] = [
  ConsumablesProductDetailsContainerComponent,
  ProductSpecificationComponent,
  ProductTeaserCarouselComponent,
  StandardProductDetailsContainerComponent,
];
